document.addEventListener("DOMContentLoaded", function () {
  const canvas = document.getElementById("captchaCanvas");
  const ctx = canvas.getContext("2d");
  const captchaInput = document.getElementById("captcha");
  const refreshBtn = document.getElementById("refreshCaptcha");
  const form = document.getElementById("registerForm");

  let captchaText = "";
  let captchaToken = "";

  // Hàm vẽ captcha lên canvas
  function drawCaptcha(text) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Background
    ctx.fillStyle = "#7e7e7e";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.font = "italic bold 22px 'Arial Black', Tahoma, 'Segoe UI', sans-serif";

    // Tính tổng chiều rộng toàn bộ chữ
    let totalTextWidth = 0;
    for (let i = 0; i < text.length; i++) {
      totalTextWidth += ctx.measureText(text[i]).width;
    }

    let currentX = (canvas.width - totalTextWidth) / 2;

    for (let i = 0; i < text.length; i++) {
      ctx.save();

      const char = text[i];
      const y = canvas.height / 2 + 8;
      const shear = (Math.random() - 0.5) * 0.2;

      ctx.translate(currentX, y);
      ctx.transform(1, 0, shear, 1, 0, 0);

      ctx.lineWidth = 2;
      ctx.strokeStyle = "#7e7e7e";
      ctx.strokeText(char, 0, 0);

      ctx.fillStyle = "#000";
      ctx.fillText(char, 0, 0);

      ctx.restore();

      // Tăng currentX theo chiều rộng ký tự
      currentX += ctx.measureText(char).width;
    }
  }

  // Hàm load captcha từ server
  function loadCaptcha() {
    $.ajax({
      url: 'https://hitclub-captcha.voni-154.workers.dev/',
      type: 'GET',
      dataType: 'json',
      beforeSend: function() {
        // Hiển thị trạng thái đang tải (optional)
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = "#f0f0f0";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = "#666";
        ctx.font = "14px Arial";
        ctx.textAlign = "center";
        ctx.fillText("Đang tải...", canvas.width / 2, canvas.height / 2);
      },
      success: function(res) {
        if (res.success) {
          captchaText = res.captcha;
          captchaToken = res.token;

          // Vẽ captcha lên canvas
          drawCaptcha(res.captcha);

          // Lưu token vào hidden input (nếu có)
          if (document.getElementById("token")) {
            document.getElementById("token").value = res.token;
          } else {
            // Tạo hidden input nếu chưa có
            const hiddenInput = document.createElement("input");
            hiddenInput.type = "hidden";
            hiddenInput.id = "token";
            hiddenInput.name = "token";
            hiddenInput.value = res.token;
            form.appendChild(hiddenInput);
          }

          // Xóa lỗi captcha cũ (nếu có)
          document.querySelectorAll(".captcha-error").forEach((el) => el.remove());
          captchaInput.value = '';
          captchaInput.classList.remove('is-invalid');

          console.log('✅ Captcha loaded:', res.captcha);
        } else {
          console.error('❌ Lỗi tạo captcha');
          showCaptchaError('Không thể tải captcha. Vui lòng thử lại!');
        }
      },
      error: function(xhr, status, err) {
        console.error('❌ AJAX lỗi:', status, err);
        console.error('Response:', xhr.responseText);
        showCaptchaError('Lỗi kết nối. Vui lòng thử lại!');
      }
    });
  }

  function showCaptchaError(message) {
    // Xóa lỗi cũ
    document.querySelectorAll(".captcha-error").forEach((el) => el.remove());

    const errorDiv = document.createElement("div");
    errorDiv.className = "errors captcha-error";
    errorDiv.textContent = message;

    const target = captchaInput.parentElement.parentElement;
    target.parentNode.insertBefore(errorDiv, target.nextSibling);
  }

  // Refresh captcha khi click
  refreshBtn.addEventListener("click", function() {
    loadCaptcha();
  });

  // Custom validator method
  jQuery.validator.addMethod(
      "validCaptcha",
      function (value, element) {
        // So sánh không phân biệt hoa thường
        return value.trim().toUpperCase() === captchaText.toUpperCase();
      },
      "Captcha không đúng"
  );

  // Load captcha lần đầu khi trang load
  loadCaptcha();
});
